import { FC, SVGProps } from 'react';

const ErrorV2: FC<SVGProps<SVGSVGElement>> = (
  props: SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      width="34"
      height="28"
      viewBox="0 0 34 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 20.5C17.8125 20.5 18.5 21.1875 18.4375 22C18.4375 22.875 17.8125 23.5 17 23.5C16.1875 23.5 15.5 22.875 15.5 22C15.5 21.1875 16.125 20.5 17 20.5ZM17 18C16.4375 18 16 17.5625 16 17V8C16 7.5 16.5 7 17 7C17.4375 7 17.9375 7.5 17.9375 8V17C17.9375 17.5625 17.5 18 17 18ZM32.5 22.875C33.125 23.9375 33.125 25.1875 32.5 26.25C31.875 27.375 30.75 28 29.5 28H4.5C3.1875 28 2.0625 27.375 1.4375 26.25C0.8125 25.1875 0.8125 23.9375 1.4375 22.875L13.9375 1.75C14.5625 0.6875 15.6875 0 17 0C18.25 0.0625 19.375 0.6875 20 1.75L32.5 22.875ZM30.75 25.25C31.0625 24.8125 31 24.3125 30.75 23.875L18.25 2.75C18 2.3125 17.5 2.0625 17 2C16.9375 2 17 2 17 2C16.4375 2 15.9375 2.3125 15.6875 2.75L3.1875 23.875C2.9375 24.3125 2.875 24.8125 3.1875 25.25C3.4375 25.75 3.9375 26 4.5 26H29.4375C30 26 30.5 25.75 30.75 25.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ErrorV2;
